import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, ZapIcon, ClockIcon } from 'lucide-react';
export function SocialProofBanner() {
  const metrics = [{
    icon: UsersIcon,
    value: '50+',
    label: 'Service Businesses'
  }, {
    icon: ZapIcon,
    value: '10,000+',
    label: 'Leads Automated'
  }, {
    icon: ClockIcon,
    value: '8 sec',
    label: 'Avg Response Time'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 1
  }} className="mt-12 pt-8 border-t border-white/20" data-id="element-243">
      <div className="grid grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-244">
        {metrics.map((metric, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 1.2 + index * 0.1
      }} className="text-center" data-id="element-245">
            <metric.icon className="w-6 h-6 text-[var(--viridia-green)] mx-auto mb-2" data-id="element-246" />
            <div className="text-2xl font-bold text-white mb-1" data-id="element-247">
              {metric.value}
            </div>
            <div className="text-sm text-gray-400" data-id="element-248">{metric.label}</div>
          </motion.div>)}
      </div>
    </motion.div>;
}